// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { BaseEntity } from '../../../../../../libs/com/MetaPattern/Product/IDE/Util/BaseEntity';
/**
 * 配置发布记录 实体类
 * 配置发布记录
 */
export class PublishSettingRecord extends BaseEntity {
  /** 命名空间id : 命名空间id */
  private _nameSpaceId: string;

  /** 设置：命名空间id */
  public get nameSpaceId() {
    return this._nameSpaceId;
  }

  /** 获取：命名空间id */
  public set nameSpaceId(value: string) {
    this._nameSpaceId = value;
  }

  /** 发布内容 : 发布内容 */
  private _content: string;

  /** 设置：发布内容 */
  public get content() {
    return this._content;
  }

  /** 获取：发布内容 */
  public set content(value: string) {
    this._content = value;
  }

  /** 分组名称 : 分组名称 */
  private _groupName: string;

  /** 设置：分组名称 */
  public get groupName() {
    return this._groupName;
  }

  /** 获取：分组名称 */
  public set groupName(value: string) {
    this._groupName = value;
  }

  /** 配置发布状态 : 配置发布状态 */
  private _publishSettingStatus: boolean;

  /** 设置：配置发布状态 */
  public get publishSettingStatus() {
    return this._publishSettingStatus;
  }

  /** 获取：配置发布状态 */
  public set publishSettingStatus(value: boolean) {
    this._publishSettingStatus = value;
  }

  /** 总任务Id : 总任务Id */
  private _taskId: string;

  /** 设置：总任务Id */
  public get taskId() {
    return this._taskId;
  }

  /** 获取：总任务Id */
  public set taskId(value: string) {
    this._taskId = value;
  }

  /** 工作区间名称 : 工作区间名称 */
  private _workSpaceName: string;

  /** 设置：工作区间名称 */
  public get workSpaceName() {
    return this._workSpaceName;
  }

  /** 获取：工作区间名称 */
  public set workSpaceName(value: string) {
    this._workSpaceName = value;
  }

  /** 产品名称 : 产品名称 */
  private _productName: string;

  /** 设置：产品名称 */
  public get productName() {
    return this._productName;
  }

  /** 获取：产品名称 */
  public set productName(value: string) {
    this._productName = value;
  }

  /** 应用名称 : 应用名称 */
  private _appName: string;

  /** 设置：应用名称 */
  public get appName() {
    return this._appName;
  }

  /** 获取：应用名称 */
  public set appName(value: string) {
    this._appName = value;
  }

  /** 应用唯一标识 : 应用唯一标识 */
  private _appKey: string;

  /** 设置：应用唯一标识 */
  public get appKey() {
    return this._appKey;
  }

  /** 获取：应用唯一标识 */
  public set appKey(value: string) {
    this._appKey = value;
  }

  constructor() {
    super();
    this._nameSpaceId = '';
    this._content = '';
    this._groupName = '';
    this._publishSettingStatus = false;
    this._taskId = '';
    this._workSpaceName = '';
    this._productName = '';
    this._appName = '';
    this._appKey = '';
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: PublishSettingRecord, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.nameSpaceId = element.nameSpaceId;
      this.content = element.content;
      this.groupName = element.groupName;
      this.publishSettingStatus = element.publishSettingStatus;
      this.taskId = element.taskId;
      this.workSpaceName = element.workSpaceName;
      this.productName = element.productName;
      this.appName = element.appName;
      this.appKey = element.appKey;
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.nameSpaceId = json.NameSpaceId;
    this.content = json.Content;
    this.groupName = json.GroupName;
    this.publishSettingStatus = json.PublishSettingStatus;
    this.taskId = json.TaskId;
    this.workSpaceName = json.WorkSpaceName;
    this.productName = json.ProductName;
    this.appName = json.AppName;
    this.appKey = json.AppKey;
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.NameSpaceId = this.nameSpaceId;
    json.Content = this.content;
    json.GroupName = this.groupName;
    json.PublishSettingStatus = this.publishSettingStatus;
    json.TaskId = this.taskId;
    json.WorkSpaceName = this.workSpaceName;
    json.ProductName = this.productName;
    json.AppName = this.appName;
    json.AppKey = this.appKey;
  }

  static Create(json: any): PublishSettingRecord {
    const publishSettingRecord = new PublishSettingRecord();
    publishSettingRecord.Deserialize(json);
    publishSettingRecord.json = json;
    return publishSettingRecord;
  }
}
